import { render, staticRenderFns } from "./FrontContent.vue?vue&type=template&id=709ad975"
import script from "./FrontContent.vue?vue&type=script&setup=true&lang=js"
export * from "./FrontContent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports